import React, {useEffect, useState} from 'react'
import {useFilAriane} from '../../../../../app/contexts/FilArianeContext'
import {Tooltip} from 'react-tooltip'

const FilAriane = () => {
  const {
    steps,
    statut,
    etape,
    panierAriane,
    demandeAriane,
    listePOTAriane,
    setCommandeAriane,
    setListePOTAriane,
    setSteps,
    setSelectedPOTAriane
  } = useFilAriane();

  const demande = demandeAriane ?? null;
  const commandes = demande?.commandes ?? [];

  // Verification si l'une des commandes de la demande est un virement
  const haveVirement = commandes?.filter((commande) =>
    commande?.statut === "BLOQU" && commande?.codePaiement === "virement" && commande?.pot === null
  )?.length > 0 ?? false
  // Vérification si il y a un POT bloqué dans les commandes
  const haveBlockedPOT = listePOTAriane?.length > 0 ?? false
  // Condition d'affichage du bouton de modification du status / POTs
  const displayButton = (haveVirement || haveBlockedPOT)

  const panier = panierAriane ?? [];
  const nbPanier = panier?.length ?? 0;
  const nbPropo = panier?.filter(piece => piece?.statut === "PROPO")?.length ?? 0;
  const nbAccep = panier?.filter(piece => piece?.statut === "ACCEP")?.length ?? 0;
  const nbRefus = panier?.filter(piece => piece?.statut === "REFUS")?.length ?? 0;
  const nbBloqu = panier?.filter(piece => piece?.statut === "BLOQU")?.length ?? 0;

  // Ordre du fil d'Ariane
  const fullStep = ['NOUVE', 'ASSIG', 'PROPO', 'REFUS', 'ACCEP', 'BLOQU'];

  // Méthode pour afficher chaque étape + son titre personnalisé
  const displayLabelle = (step) => {
    if (step.label === 'Nouvelle') {
      return <div className='step-label fs-7'>Nouvelle</div>
    } else if (step.label === 'Assignee') {
      return <div className='step-label fs-7'>En cours</div>
    } else if (step.label === 'Panier') {
      return <div className='step-label fs-7'>Panier : <strong>{step?.value ? step?.value : 0} pièce(s)</strong></div>
    } else if (step.label === 'Proposee') {
      return <div className='step-label fs-7'>{step?.value ? step?.value : 0} pièce(s) Proposée(s)</div>
    } else if (step.label === 'Acceptee') {
      return <div className='step-label fs-7'>{step?.value ? step?.value : 0} pièce(s) Acceptée(s)</div>
    } else if (step.label === 'Refusee') {
      return <div className='step-label fs-7'>{step?.value ? step?.value : 0} pièce(s) Refusée(s)</div>
    } else if (step.label === 'AccepteeBloquee') {
      return <div className='step-label fs-7'>{step?.value ? step?.value : 0} pièce(s) Bloquée(s)</div>
    } else {
      return <></>
    }
  }

  // Méthode pour obtenir le status de l'étape : "done" | "active" | "inactive"
  const getStatus = (currentStep: string) => {
    const activeKey = fullStep.findIndex((item) => item === etape);
    const currentKey = fullStep.findIndex((item) => item === currentStep);
    if (currentKey === -1) return 'inactive';
    if (currentKey === activeKey) return 'active';
    if (currentKey < activeKey) return 'done';
    return 'inactive';
  };

  // Méthode personnalisée pour obtenir le status de l'étape "Nouvelle"
  // Soit le fil d'Ariane sur l'étape Nouvelle est active soit terminé
  const getNouvelleStatus = () => {
    return (etape === "NOUVE") ? "active" : (etape === "MODIF" && demande?.utilisateurAssigne === null ? 'active' : 'done')
  }

  // Méthode personnalisée pour obtenir le status de l'étape "Assignée"
  // La demande peut être assignée mais aussi modifié mais assignée
  const getAssigneeStatus = () => {
    return ((etape === "ASSIG" || etape === "INDIS") && nbPanier === 0) ? "active" : ((etape === "MODIF" && demande?.utilisateurAssigne !== null && nbPanier === 0) ? 'active' : ((nbPanier === 0) ? getStatus("ASSIG") : 'done'))
  }

  // Méthode personnalisér pour obtenir l'état du panier
  const getPanierStatus = () => {
    // Si il n'y a rien dans le panier
    if (nbPanier === 0) {
      // Durant le chargement de panier, comme il n'y a rien dans le panier
      // si l'étape supérieur est en cours ou terminé
      if (getStatus("PROPO") === 'active' || getStatus("PROPO") === 'done') return 'done'
      return 'inactive'
    } else {
      // Si il y a au moins 1 pièce dans l'une étapes supérieurs
      if (nbPropo !== 0 || nbAccep !== 0 || nbRefus !== 0 || nbBloqu !== 0) return 'done'
      else return 'active'
    }
  }

  // Méthode personnalisér pour obtenir l'état des pièces proposées
  const getProposeeStatus = () => {
    if (nbPropo > 0 && nbAccep === 0 && nbRefus === 0 && nbBloqu === 0) {
      return 'active'
    } else {
      if (nbAccep !== 0 || nbRefus !== 0 || nbBloqu !== 0) {
        return 'done'
      } else {
        return getStatus("PROPO")
      }
    }
  }

  // Méthode personnalisér pour obtenir l'état des pièces refusées
  const getRefuseeStatus = () => {
    if (nbRefus > 0 && nbAccep === 0 && nbBloqu === 0) {
      return 'active'
    } else {
      if (nbAccep !== 0 || nbBloqu !== 0) {
        return 'done'
      } else {
        return getStatus("REFUS")
      }
    }
  }

  // Méthode personnalisér pour obtenir l'état des pièces acceptées
  const getAccepteeStatus = () => {
    if (nbAccep > 0 && nbBloqu === 0) {
      return 'active'
    } else if (nbAccep > 0 && nbBloqu > 0) {
      return 'done'
    } else {
      return getStatus("ACCEP")
    }
  }

  // Méthode personnalisér pour obtenir l'état des pièces acceptées
  const getBloqueeStatus = () => {
    if (nbBloqu > 0) {
      return 'active'
    } else {
      return getStatus("BLOQU")
    }
  }

  // Etape dynamique après "Proposée"
  const DYNAMIC_STATES = [
    {label: 'Refusee', status: etape === '' ? 'inactive' : getRefuseeStatus(), value: nbRefus},
    {label: 'Acceptee', status: etape === '' ? 'inactive' : getAccepteeStatus(), value: nbAccep},
    {label: 'AccepteeBloquee', status: etape === '' ? 'inactive' : getBloqueeStatus(), value: nbBloqu},
  ];

  // Filtre des étapes dynamiques
  const getDynamicSteps = () =>
    DYNAMIC_STATES
      .filter(s => {
        if (s.value > 0) return true;
        return s.label === "AccepteeBloquee" && s.status === "active"
      });

  // useEffect pour conserver les étapes à jour par rappot à l'étape et le panier actif
  useEffect(() => {
    setSteps([
      {label: 'Nouvelle', status: etape === '' ? 'inactive' : getNouvelleStatus()},
      {label: 'Assignee', status: etape === '' ? 'inactive' : getAssigneeStatus()},
      {label: 'Panier', status: etape === '' ? 'inactive' : getPanierStatus(), value: nbPanier},
      {label: 'Proposee', status: etape === '' ? 'inactive' : getProposeeStatus(), value: nbPropo},
      ...getDynamicSteps(),
    ])
  }, [etape, panierAriane, demande]);

  // useEffect pour obtenir la liste des POT bloquée et définir la condition d'affichage du bouton
  useEffect(() => {
    const listPOT =
      demandeAriane?.commandes?.length > 0
        ? commandes
            .flatMap((commande) =>
              commande?.commandeItems?.map((item) => {
                let status = 'A_PROPO'
                if (item?.clientDemandePieceProposee?.dateEchec !== null) {
                  status = 'ECHEC'
                } else if (item?.clientDemandePieceProposee?.isAccepted === true) {
                  status = 'ACCEP'
                } else if (item?.clientDemandePieceProposee?.isAcceptedBlocked === true) {
                  status = 'BLOQU'
                } else if (item?.clientDemandePieceProposee?.isRefused === true) {
                  status = 'REFUS'
                }

                if (item?.clientDemandePieceProposee?.isAcceptedBlocked === true) {
                  return (
                    {
                      ...item?.clientDemandePieceProposee?.typePiecePOT,
                      demande: demande,
                      status: status,
                    } ?? []
                  )
                } else {
                }
              })
            )
            .filter((item) => item?.id)
        : []
    setListePOTAriane(listPOT)
    setSelectedPOTAriane(listPOT?.[0] ?? null)
    setCommandeAriane(demandeAriane?.commandes ?? [])
  }, [demandeAriane])

  const renderBagdeStatus = (statut) => {
    let className = ''
    if (statut === 'REFUSE' || statut === 'ACCEPTEE BLOQUE') {
      className = 'badge-danger'
    } else if (statut === 'ACCEPTEE INDISPONIBLE') {
      className = 'badge-light-warning-echec'
    } else {
      className = 'badge-warning'
    }

    return (
      <span
        className={`value fw-bold badge ${className} text-white`}
      >
        {statut}
      </span>
    )
  }

  return (
    <div className='d-flex gap-5'>
      {steps.length > 0 && (
        <>
          <div className='stepper'>
            {steps.map((step) => (
              <div className={`step ${step.status}`}>
                {displayLabelle(step)}
                <div className='step-dot'>
                  {step.status === 'active' && (<div className='inner'></div>)}
                </div>
              </div>
            ))}
          </div>

          <div className={'d-flex align-items-center gap-6'}>
            {statut && (
              <div className='statut-bar fs-7 pt-0'>
                Statut :
                {renderBagdeStatus(statut)}
              </div>
            )}
            {(displayButton) && (
              <span
                className={`btn btn-icon btn-bg-light btn-sm`}
                data-bs-toggle={(haveVirement || haveBlockedPOT) ? 'modal' : undefined}
                data-bs-target={haveVirement ? `#confirmBVModal` : (haveBlockedPOT ? `#modalPOT` : undefined)}
                data-bs-dismiss={(haveVirement || haveBlockedPOT) ? 'modal' : undefined}
                onClick={() => {
                  if (haveBlockedPOT) setSelectedPOTAriane(listePOTAriane?.[0] ?? null)
                  setListePOTAriane(listePOTAriane)
                }}
              >
                <i
                  className='bi bi-bank2 fs-2 cursor-pointer'
                  data-tooltip-id='tooltip'
                  data-tooltip-content='Modifier le statut de cette commande bloquée'
                  data-tooltip-place='right'
                ></i>
              </span>
            )}
          </div>
          <Tooltip id='tooltip' />
        </>
      )}
    </div>
  )
}

export {FilAriane}
